var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import MeetingDomainService from "../Domain/Meeting/Meeting.service";
import MeetingTypeDomainService from "../Domain/MeetingType/MeetingType.service";
import { getApiClient } from "../../services/AxiosClients";
import DateService from "./Shared/Date.service";
const MEETING_URL = "/aviso/meeting";
let schedulerEnabledPromise = null;
export default class MeetingService {
    static getAdvisorMeetings(params) {
        return FetchService.getPagedResponse("/aviso/advisor/getAdvisorMeetings", params);
    }
    static getMeeting(meetingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = yield FetchService.getSingleResponse(MEETING_URL + "/getMeeting", {
                id: meetingId,
            });
            return MeetingDomainService.fromJSON(json);
        });
    }
    static createMeetingFromMeetingRequest(meetingRequestId) {
        return FetchService.postSingleResponse("/aviso/advisor/createMeetingFromMeetingRequest", {
            meetingRequestId,
        }).then(MeetingDomainService.fromJSON);
    }
    static searchStaffMembersOfMeetingsWithStudent(studentPersonId, query, max = 20, offset = 0) {
        return FetchService.getSingleResponse("/aviso/meeting/searchStaffMembersOfMeetingsWithStudent", { studentPersonId, query, max, offset });
    }
    static getMeetingsForStudent(studentAffiliationId, options = {}) {
        return FetchService.get("/aviso/advisor/getMeetings", {
            affiliationId: studentAffiliationId,
            max: options.max || 10,
            offset: options.offset || 0,
        }).then((response) => (Object.assign(Object.assign({}, response), { meetings: 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            response.meetings &&
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                response.meetings.map(MeetingDomainService.fromJSON) })));
    }
    /**
     * This service targets two different endpoints based on the current provided app to avoid students scheduling
     * meetings on the behalf of other people
     */
    static scheduleMeeting(meeting) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = yield FetchService.postSingleResponse(meeting.virtualizedAppName === "student"
                ? "/aviso/meeting/schedule"
                : "/aviso/meeting/staffSchedule", {
                serviceOfferingId: meeting.serviceOfferingId,
                staffPersonId: meeting.staffPersonId,
                studentPersonId: meeting.studentPersonId,
                serviceDeliveryLocationId: meeting.serviceDeliveryLocationId,
                startTime: meeting.startTime,
                virtualizedAppName: meeting.virtualizedAppName,
                meetingModalityId: meeting.meetingModalityId,
                meetingStatusId: meeting.meetingStatusId,
                studentQuestion: meeting.studentQuestion,
                studentPhoneNumber: meeting.studentPhoneNumber,
            });
            return MeetingDomainService.fromJSON(json);
        });
    }
    static createMeeting(meeting) {
        return FetchService.postSingleResponse("/aviso/meeting/create", {
            startTime: meeting.startTime,
            endTime: meeting.endTime,
            staffPersonId: meeting.staffPersonId,
            studentPersonId: meeting.studentPersonId,
            locationId: meeting.locationId,
            meetingRequestId: meeting.meetingRequestId,
            serviceDeliveryLocationId: meeting.serviceDeliveryLocationId,
            meetingTypeId: meeting.meetingTypeId,
            studentQuestion: meeting.studentQuestion,
            staffComments: meeting.staffComments,
            selfServiceCheckIn: meeting.selfServiceCheckIn,
            transcriptCourseIds: meeting.transcriptCourseIds,
            serviceOfferingIds: meeting.serviceOfferingIds,
            shouldSendInvite: meeting.shouldSendInvite,
            meetingModalityId: meeting.meetingModalityId,
            meetingStatusId: meeting.meetingStatusId,
            studentPhoneNumber: meeting.studentPhoneNumber,
        }).then((json) => MeetingDomainService.fromJSON(json));
    }
    static editMeeting(meeting) {
        return FetchService.postSingleResponse("/aviso/meeting/edit", {
            id: meeting.id,
            startTime: meeting.startTime,
            endTime: meeting.endTime,
            staffPersonId: meeting.staffPersonId,
            studentPersonId: meeting.studentPersonId,
            locationId: meeting.locationId,
            meetingRequestId: meeting.meetingRequestId,
            serviceDeliveryLocationId: meeting.serviceDeliveryLocationId,
            meetingTypeId: meeting.meetingTypeId,
            studentQuestion: meeting.studentQuestion,
            staffComments: meeting.staffComments,
            selfServiceCheckIn: meeting.selfServiceCheckIn,
            transcriptCourseIds: meeting.transcriptCourseIds,
            serviceOfferingIds: meeting.serviceOfferingIds,
            shouldSendInvite: meeting.shouldSendInvite,
            meetingModalityId: meeting.meetingModalityId,
            meetingStatusId: meeting.meetingStatusId,
            studentPhoneNumber: meeting.studentPhoneNumber,
        }).then((json) => MeetingDomainService.fromJSON(json));
    }
    static getMeetingLocations() {
        return FetchService.get("/aviso/advisor/getMeetingLocations");
    }
    static getServiceOfferingsByServiceDeliveryLocation(serviceDeliveryLocationId) {
        return FetchService.get("/aviso/serviceOffering/getServiceOfferingsByServiceDeliveryLocation", { id: serviceDeliveryLocationId });
    }
    /**
     * New service method to get the service offerings either by location Id or
     * serviceDeliveryLocation Id
     * */
    static getServiceOfferings(locationId, serviceDeliveryLocationId) {
        return FetchService.get("/aviso/serviceOffering/getServiceOfferings", {
            locationId,
            serviceDeliveryLocationId,
        });
    }
    static getMeetingTypes(active) {
        return FetchService.getSingleResponse("/aviso/meetingType/getMeetingTypes", {
            active,
        }).then((types) => types.map(MeetingTypeDomainService.fromJSON));
    }
    static cancelMeeting(meetingId) {
        // Send meeting id as a param instead of in the body even though this is a post.
        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        return FetchService.postSingleResponse(`/aviso/calendar/cancel?meetingId=${meetingId}`);
    }
    static markMeetingAsNoShow(meetingId) {
        // Send meeting id as a param instead of in the body even though this is a post.
        // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        return FetchService.postSingleResponse(`/aviso/calendar/markMeetingAsNoShow?meetingId=${meetingId}`);
    }
    static isSchedulerEnabled() {
        if (!schedulerEnabledPromise) {
            schedulerEnabledPromise = FetchService.getSingleResponse("/aviso/meeting/isSchedulerEnabled");
        }
        return schedulerEnabledPromise;
    }
    static finishMeeting(meetingId) {
        return FetchService.postSingleResponse("/aviso/advisor/finishMeeting", {
            meetingId,
        });
    }
    static canScheduleMeetingsForOthers() {
        return FetchService.getSingleResponse("/aviso/meeting/canScheduleMeetingsForOthers");
    }
    // prettier-ignore
    static getNumMeetingsScheduledCancelledForStudent(studentId, period, rangeFrom, rangeTo) {
        return getApiClient()
            .get("/stats/getNumMeetingsScheduledCancelledForStudent", {
            params: { studentId, period, rangeFrom, rangeTo },
        })
            .then(({ data }) => 
        // @ts-expect-error - TS7006 - Parameter 'datum' implicitly has an 'any' type.
        data.map((datum) => ({
            numScheduled: datum.numScheduled,
            numCancelled: datum.numCancelled,
            date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)),
        })));
    }
}
